export default __webpack_public_path__ + "static/media/98-04_header_invoice.fc44058e.png";